// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f1fa731e","879":"0b859943"}[chunkId] + ".chunk.js";
};